// @flow
// Action Types
const actionPrefix: string = '@@datatable/users/'
export const SELECT_RECORDS = `${actionPrefix}SELECT_RECORDS`
export const UPDATE_FILTER = `${actionPrefix}UPDATE_FILTER`

// Datatable
export const DATATABLE_NAME = 'Users'

// Record attrs
export const ATTR_LAST = 'last'
export const ATTR_FIRST = 'first'
export const ATTR_USERNAME = 'username'
export const ATTR_PHONE = 'phone'
export const ATTR_EMAIL = 'email'
export const ATTR_ID = 'id'
export const ATTR_PROP_HIDE_CHECKBOX = 'prop_hide_checkbox'
